import { Dialog } from "@dash/dialog";
import { Dropdown } from "@dash/dropdown";
import { Button, TextField } from "@dash/form";
import { useDeviceType } from "@dash/mq";
import React from "react";
import { MdMoreVert, MdOutlineEdit } from "react-icons/md";
import { useQueryClient } from "react-query";

import { useClientManager } from "@megaron/react-clients";
import { TicketDetailDto } from "@megaron/support-contracts";

import { useSupportTicketEditable } from "../shared/useSupportTicketEditable";
import { updateTicketPayload } from "./supportUpdateTicketPayload";

type Props = {
  ticket: TicketDetailDto;
};

export const SupportTicketHeaderActions: React.FC<Props> = ({ ticket }) => {
  const queryClient = useQueryClient();
  const { isMobile } = useDeviceType();
  const [isRenameOpen, setIsRenameOpen] = React.useState(false);
  const [draft, setDraft] = React.useState(ticket.subject);
  const updateMutation = useClientManager("support").updateTicket().useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["support", "getTicket"] });
    },
  });

  const isBusy = "isLoading" in updateMutation ? updateMutation.isLoading : false;
  const isEditable = useSupportTicketEditable(ticket.status);

  React.useEffect(() => {
    setDraft(ticket.subject);
  }, [ticket.subject]);

  const closeRename = () => {
    setDraft(ticket.subject);
    setIsRenameOpen(false);
  };

  return (
    <>
      <Dropdown openButton={<MdMoreVert color="white" css={{ cursor: "pointer", fontSize: "24px" }} />}>
        {isEditable && (
        <div
          css={{ display: "flex", alignItems: "center", gap: "8px", padding: "6px 8px", cursor: "pointer" }}
          onClick={() => {
            setDraft(ticket.subject);
            setIsRenameOpen(true);
          }}
        >
          <MdOutlineEdit />
          Zmień nazwę
        </div>
        )}
      </Dropdown>
      {isRenameOpen && (
        <Dialog onClose={closeRename} placement={isMobile ? "top" : "center"} header="Zmień nazwę" css={{ width: "400px" }}>
          <div css={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
            <TextField value={draft} onChange={setDraft} isDisabled={isBusy} autoFocus css={{ width: "100%", padding: 0 }} />
            <div css={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
              <Button variant="text" onClick={closeRename} isDisabled={isBusy}>
                Anuluj
              </Button>
              <Button
                onClick={() => {
                  const subject = draft.trim();
                  if (!subject || subject === ticket.subject) {
                    closeRename();
                    return;
                  }
                  updateMutation.mutate(updateTicketPayload(ticket, { subject }), {
                    onSuccess: () => {
                      setIsRenameOpen(false);
                    },
                  });
                }}
                isDisabled={!draft.trim() || draft.trim() === ticket.subject || isBusy}
                isLoading={isBusy}
              >
                Zapisz
              </Button>
            </div>
          </div>
        </Dialog>
      )}
    </>
  );
};
